import { FC, useCallback, useState, useEffect, useMemo } from 'react'
import * as styles from 'components/features/videoCalls/VideoFrame/VideoFrame.styl'
import { StreamId } from 'components/features/videoCalls/types/agoraTypes'
import { SubtreeMutation } from 'components/features/pfm/SubtreeMutation/SubtreeMutation'
import { generate } from 'randomstring'
import { DEFAULT_VIDEO_WIDTH, DEFAULT_VIDEO_HEIGHT } from 'components/features/videoCalls/constants'
import { agoraInstances } from 'components/features/videoCalls/agoraInstances'

type VideoFrameProps = {
  streamId: StreamId | null
  onSizeChange: (props: { width: number, height: number }) => void
}
export const VideoFrame: FC<VideoFrameProps> = (props) => {
  const { streamId, onSizeChange } = props

  const [size, setSize] = useState({ width: DEFAULT_VIDEO_WIDTH, height: DEFAULT_VIDEO_HEIGHT })
  const [cache, render] = useState({})
  const handleSubtreeChange = useCallback(() => {
    render({})
  }, [])

  useEffect(() => {
    const videoNode = document.getElementById(`video${ streamId }`) as HTMLVideoElement
    if (!videoNode) {
      return
    }

    const handler = () => {
      setSize((prevState) => {
        if (prevState.width !== videoNode.videoWidth || prevState.height !== videoNode.videoHeight) {
          return {
            width: videoNode.videoWidth,
            height: videoNode.videoHeight,
          }
        }
        return prevState
      })
    }

    videoNode.addEventListener('resize', handler)
    return () => {
      videoNode.removeEventListener('resize', handler)
    }
  }, [cache, streamId])

  useEffect(() => {
    onSizeChange(size)
  }, [size, onSizeChange])

  return (
    <SubtreeMutation onChange={ handleSubtreeChange } className={ styles.subtreeWrapper }>
      <VideoStreamPlayer streamId={ streamId } />
    </SubtreeMutation>
  )
}

type VideoStreamPlayerProps = {
  streamId: StreamId | null
}
const VideoStreamPlayer: FC<VideoStreamPlayerProps> = (props) => {
  const { streamId } = props
  const nodeId = useMemo(generate, [])

  const stream = agoraInstances.streams.get(streamId as any)
  useEffect(() => {
    if (!stream || !streamId) {
      return
    }

    try {
      stream.play(nodeId, { fit: 'contain' }, (error) => {
        if (!error) {
          return
        }
        console.log('VideoFrame error', error)
      })
    } catch (error) {
      console.log('play error', error)
    }

    return () => {
      try {
        if (stream.isPlaying()) {
          stream.stop()
        }
      } catch (error) {
        console.log('unplay error', error)
      }
    }
  }, [nodeId, stream, streamId])

  return (
    <div
      id={ nodeId }
      className={ styles.video }
    />
  )
}
